import { DocumentGeneralMultiTableEntity } from '../../../generated-api';
import ocrTypeNameDefinitions from '../../../utils/ocrTypeNameDefinitions';
import { VariableLengthInputFormResult } from '../VariableLengthInputForm';
import {
  ChildTable,
  convertGeneralTableToCSV,
  entityToModalEntities,
  GeneralTableDataFormComponent,
} from './generalTableResultPageDefinition';
import { OcrResultPageDefinition, ResultPageDocument } from './types';

type FormResult = {
  resultTables: Record<number, VariableLengthInputFormResult<DocumentGeneralMultiTableEntity>>;
};
function formDataToEntity(data: FormResult): DocumentGeneralMultiTableEntity {
  const tables = Object.values(data.resultTables);
  const newTables = tables.map(({ columns, table }) => [
    [...Object.values(columns)],
    ...Object.values(table).map((values) => Object.values(values)),
  ]);

  return {
    type: 'general_multi_table',
    tables: newTables,
  };
}

const generalMultiTableResultPageDefinition: OcrResultPageDefinition<DocumentGeneralMultiTableEntity> = {
  name: ocrTypeNameDefinitions.general_multi_table,
  tabs: [
    {
      csvColumns: {},
      tableColumns: [
        {
          title: '表の数',
          dataIndex: ['latest_revision', 'tables'],
          render: (value: string[][][]) => value.length,
        },
      ],
      tableExpandable: {
        expandedRowRender: ({ latest_revision: record }) =>
          record.tables.map((table, tableIndex) => <ChildTable key={tableIndex} table={table} />),
      },
    },
  ],
  formComponent: GeneralTableDataFormComponent,
  entityToModalEntities,
  formDataToEntity,
  csvDataConverters: [
    {
      labelName: '',
      converter: (data: ResultPageDocument<DocumentGeneralMultiTableEntity>[]) => {
        return data
          .filter((entity) => entity.latest_revision.tables != null)
          .flatMap((entity, index) =>
            entity.latest_revision.tables.map((csv, tableIndex) => ({
              fileNameSuffix: `${entity.page ? `${entity.page}_${index}` : index}_${tableIndex}`,
              csv: convertGeneralTableToCSV(csv),
            }))
          );
      },
    },
  ],
  canOutputAsSingleCsvFile: true,
};

export default generalMultiTableResultPageDefinition;
